import { render, staticRenderFns } from "./PermissaoCreate.vue?vue&type=template&id=15366668&scoped=true&"
import script from "./PermissaoCreate.vue?vue&type=script&lang=js&"
export * from "./PermissaoCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15366668",
  null
  
)

export default component.exports